import React from "react"
import Users from "@/components/Users"

export default function UsersView() {
  return <Users />
}
